import { useEffect, useRef } from 'react';
import { attachBoardPointer } from '../utils/attachBoardPointer';

/** Left-drag pans. Right-drag or Alt-drag draws a selection box. */
export function useBoardPointer({
  wrapRef,
  worldRef,
  boxRef,
  cameraRef,
  flyFrameRef,
  gestureRef,
  tasksRef,
  positionsRef,
  boxesRef,
  selectedRef,
  onSelectionChangeRef,
  onEmptyContextMenuRef,
}) {
  const panningRef = useRef(null);
  const boxDragRef = useRef(null);

  useEffect(() => {
    const wrap = wrapRef.current;
    if (!wrap) return undefined;
    return attachBoardPointer({
      wrap,
      worldRef,
      boxRef,
      cameraRef,
      flyFrameRef,
      gestureRef,
      panningRef,
      boxDragRef,
      tasksRef,
      positionsRef,
      boxesRef,
      selectedRef,
      onSelectionChangeRef,
      onEmptyContextMenuRef,
    });
  }, [
    wrapRef,
    worldRef,
    boxRef,
    cameraRef,
    flyFrameRef,
    gestureRef,
    tasksRef,
    positionsRef,
    boxesRef,
    selectedRef,
    onSelectionChangeRef,
    onEmptyContextMenuRef,
  ]);
}
